import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../translations/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get language from localStorage or default to Italian
    const savedLanguage = localStorage.getItem('allmx_language');
    return savedLanguage || 'it';
  });

  useEffect(() => {
    // Save language preference to localStorage
    localStorage.setItem('allmx_language', language);
  }, [language]);

  const supportedLanguages = ['it', 'en', 'es'];

  const toggleLanguage = () => {
    setLanguage(prev => {
      const idx = supportedLanguages.indexOf(prev);
      const nextIdx = (idx + 1) % supportedLanguages.length;
      return supportedLanguages[nextIdx];
    });
  };

  const t = translations[language] || translations.it;

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    supportedLanguages,
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
